// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import './styles/fonts.css';
import './index.css';

import { ThemeProvider } from "./context/ThemeContext";
import { ThemeProvider as MTThemeProvider } from "@material-tailwind/react"; 
import { AuthProvider } from "./context/AuthContext";
import { QueueProvider } from "./context/QueueContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MTThemeProvider>
      <ThemeProvider>
        <AuthProvider>
          <QueueProvider>
            <App />
          </QueueProvider>
        </AuthProvider>
      </ThemeProvider>
    </MTThemeProvider>
  </React.StrictMode>
);